import React, { useEffect, useState } from "react";
import "../../assets/css/header.css";
import logo from "../../assets/images/logo3.png";
import { useTranslation } from "react-i18next";
import i18next from 'i18next';

export default function Header() {
  const { t } = useTranslation();

  // Set language according current local
  useEffect(() => {
    i18next.changeLanguage(navigator.language === 'en-US' ? 'en' : 'fr'); // Change the i18next language
    localStorage.setItem("handleSelectedLanguage", navigator.language === 'en-US' ? 'english' : 'guinea');
  }, [navigator.language]);

  const downloadPostmanCollection = async () => {
    try {
      const response = await fetch(
        "https://api.postman.com/collections/17820961-8dbc41b5-db8a-419e-a768-7dce18896247?access_key=PMAT-01JVEY76WSDH76BZGCPB7RKEHA"
      );
      if (!response.ok) {
        throw new Error("Failed to fetch collection");
      }
      const data = await response.json();

      const file = new Blob([JSON.stringify(data, null, 2)], {
        type: "application/json",
      });
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(file);
      downloadLink.download = "BCTPay_Postman_Collection.json";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download Postman Collection.");
    }
  };

  return (
    <>
      {/* desktop organizer header */}
      <div className="header-bottam">
        <div className="header-img-logo">
          <img src={logo} />
        </div>
        <ul className="navigate-n">
          <li className="header-nav">{t("main.developerDocuments.API_Documentation")}</li>
          <li className="header-nav">
            <button
              onClick={downloadPostmanCollection}
              className="download-postman-btn"
            >
              {t("main.developerDocuments.Download_Postman_Collection")}
            </button>
          </li>
        </ul>
      </div>
    </>
  );
}
